import { Component, OnInit } from '@angular/core';
import { NetworkMonitorService } from 'ngx-network-monitor'; //Custom Package Made By Daniel
import { environment } from '../../../../environments/environment';
import { IconifyComponent } from '../../iconography/iconify/iconify.component';

@Component({
  selector: 'app-network-indicator',
  standalone: true,
  templateUrl: './network-indicator.component.html',
  imports: [
    IconifyComponent
  ],
  styleUrl: './network-indicator.component.scss'
})
export class NetworkIndicatorComponent implements OnInit {

  networkConnection: 'ONLINE' | 'SLOW' | 'OFFLINE' = 'ONLINE';

  constructor(private networkMonitor: NetworkMonitorService){}

  ngOnInit(): void {
    this.networkMonitor.networkStatus$.subscribe(status => {
      if (!(status.online)) {
        this.networkConnection = 'OFFLINE'
      } else if (status.poorConnection) {
        this.networkConnection = 'SLOW'
      } else {
        this.networkConnection = 'ONLINE'
      }
    });
  }

  get isUnderMaintenance(){
    return environment.undergoing_deployment
  }


}
